import { type BootFileParams as QuasarBootFileParams } from "@quasar/app-vite";
import type Rollbar from "rollbar";
import type {
  App as VueApp,
  AppConfig as VueAppConfig,
  ComponentCustomProperties,
} from "vue";
import type { RouteLocationNormalizedGeneric, Router } from "vue-router";

import type DialogService from "shared/modals/DialogService";
import type ModalService from "shared/modals/ModalService";
import type activities from "shared/services/activities";
import type ApiClient from "shared/services/api/ApiClient";
import type features from "shared/services/features";
import type Permissions from "shared/services/Permissions";

import type { AlertDialog, ErrorDialog, ToastDialog } from "./alert";
import {
  type mediaFeatures,
  type organisationFeatures,
  type outreachFeatures,
  type socialFeatures,
  type teaserFeatures,
} from "./authorization";
import type { bus } from "./emitter";
import type { navBar } from "./navBar";

export interface GlobalProperties extends ComponentCustomProperties {
  $activities?: typeof activities;
  $alert?: typeof AlertDialog;
  $cacheFetch?: ApiClient;
  $dialog?: typeof DialogService;
  $emitter?: typeof bus;
  $error?: typeof ErrorDialog;
  $features?: typeof features;
  $intercomEnabled?: boolean;
  $isAdminMode?: boolean;
  $isDesktop?: boolean;
  $isMobile?: boolean;
  $mediaFeatures?: typeof mediaFeatures;
  $modals?: typeof ModalService;
  $navBar?: typeof navBar;
  $organisationFeatures?: typeof organisationFeatures;
  $outreachFeatures?: typeof outreachFeatures;
  $permissions?: Permissions;
  $rollbar?: Rollbar;
  $route: RouteLocationNormalizedGeneric;
  $router: Router;
  $safeRouterPush?: Router["push"];
  $safeRouterReplace?: Router["replace"];
  $socialFeatures?: typeof socialFeatures;
  $streemApiAdmin?: ApiClient;
  $streemApiV1?: ApiClient;
  $teaserFeatures?: typeof teaserFeatures;
  $toast?: typeof ToastDialog;
  $track?: (...args: unknown[]) => void;
}

interface AppConfig extends VueAppConfig {
  globalProperties: GlobalProperties;
}

export interface App extends VueApp {
  config: AppConfig;
}

export interface BootFileParams extends QuasarBootFileParams {
  app: App;
}

/* eslint-disable import/no-mutable-exports */

let appInstance: App;

// so we can get the Vue app instance as quasar does not expose this except for boot files :(
export default ({ app }: { app: App }) => {
  appInstance = app;
};

export { appInstance };
